export const aciTvAccesories = {
    iconName: 'tv-accesories',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: [
            {
                attr: {
                    d: 'M21.04 10.53v6.283a.761.761 0 01-.76.76H4.68a.76.76 0 01-.76-.76V7.11a.761.761 0 01.76-.761h9.182M8.105 17.573l-.95 1.903M16.855 17.573l.952 1.903',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M15.405 6.896a2.972 2.972 0 105.944 0 2.972 2.972 0 00-5.944 0zM18.377 5.637v2.518M17.118 6.896h2.518',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
